import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, CheckCircle2, Sparkles, MonitorCheck, DownloadCloud, LayoutGrid } from 'lucide-react';
import { readinessConfig } from '../../data/readinessData';

export const Day1ReadinessCard: React.FC = () => {
    const { dashboardCard, softwareList, finalExpectationSection } = readinessConfig;

    return (
        <div className="relative overflow-hidden bg-white dark:bg-brand-charcoal rounded-3xl p-6 sm:p-8 border border-brand-border shadow-sm hover:shadow-xl transition-all duration-300 group">
            {/* Subtle brand glow decoration */}
            <div className="absolute -top-24 -right-24 w-60 h-60 bg-brand-emerald/10 dark:bg-brand-emerald/15 rounded-full blur-3xl pointer-events-none group-hover:scale-125 transition-transform duration-700" />
            
            <div className="relative z-10 flex flex-col lg:flex-row lg:items-center justify-between gap-6">
                {/* Left Content Area */}
                <div className="flex items-start gap-4 sm:gap-5 max-w-3xl">
                    <div className="w-14 h-14 sm:w-16 sm:h-16 rounded-2xl bg-brand-emerald/10 text-brand-emerald flex items-center justify-center shrink-0 border border-brand-emerald/20 group-hover:scale-105 transition-transform duration-300 shadow-sm">
                        <MonitorCheck size={28} className="sm:size-8" />
                    </div>

                    <div className="space-y-2">
                        <div className="flex items-center gap-2 flex-wrap">
                            <span className="px-3 py-0.5 bg-brand-emerald/10 text-brand-emerald border border-brand-emerald/20 rounded-full text-[10px] font-black uppercase tracking-widest flex items-center gap-1.5">
                                <Sparkles size={12} />
                                {dashboardCard.badge}
                            </span>
                            <span className="text-[11px] font-bold text-brand-muted uppercase tracking-wider">
                                All Cohort Participants
                            </span>
                        </div>

                        <h3 className="text-xl sm:text-2xl font-black text-brand-charcoal dark:text-white tracking-tight">
                            {dashboardCard.title}
                        </h3>

                        <p className="text-xs sm:text-sm text-brand-muted font-medium leading-relaxed">
                            {dashboardCard.description}
                        </p>

                        {/* Quick Highlights / Requirements badges */}
                        <div className="pt-2 flex flex-wrap items-center gap-2 sm:gap-3 text-[11px] font-semibold text-brand-charcoal dark:text-gray-200">
                            <div className="flex items-center gap-1.5 px-3 py-1 bg-brand-beige dark:bg-white/5 rounded-xl border border-brand-border">
                                <DownloadCloud size={13} className="text-brand-emerald" />
                                <span>{softwareList.length} Software Tools ({softwareList.map(s => s.shortName).join(', ')})</span>
                            </div>
                            <div className="flex items-center gap-1.5 px-3 py-1 bg-brand-beige dark:bg-white/5 rounded-xl border border-brand-border">
                                <LayoutGrid size={13} className="text-brand-emerald" />
                                <span>{finalExpectationSection.checklist.length} Dashboard Verification Checks</span>
                            </div>
                            <div className="flex items-center gap-1.5 px-3 py-1 bg-brand-beige dark:bg-white/5 rounded-xl border border-brand-border">
                                <CheckCircle2 size={13} className="text-emerald-500" />
                                <span>Always Accessible</span>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Right Action CTA */}
                <div className="flex flex-col sm:flex-row lg:flex-col items-stretch lg:items-end justify-center gap-3 shrink-0 pt-2 lg:pt-0 border-t lg:border-t-0 border-brand-border/60">
                    <Link
                        to="/student/readiness"
                        className="inline-flex items-center justify-center gap-3 px-6 sm:px-8 py-4 bg-brand-emerald hover:bg-brand-emerald/90 text-white rounded-2xl font-black text-xs uppercase tracking-widest shadow-xl shadow-brand-emerald/20 hover:scale-105 active:scale-95 transition-all no-underline text-center group/btn"
                    >
                        <span>{dashboardCard.ctaText}</span>
                        <ArrowRight size={16} className="transform group-hover/btn:translate-x-1 transition-transform" />
                    </Link>
                    <span className="text-[10px] text-center lg:text-right font-bold text-brand-muted uppercase tracking-wider">
                        Step-by-step video guides included
                    </span>
                </div>
            </div>
        </div>
    );
};
